/*jshint globalstrict: false*/
// TODO: Use moment.js if this becomes more complex

const MONTHS = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
const DAY = 86400000;
const NUM_DAYS = {
    week: 7,
    fortnight: 14,
    month: 30
};

export default {
    methods: {
        formatDate(date) {
            date = new Date(date);
            return `${this.convertMonthNumToStr(date.getMonth())}/${date.getDate()}/${date.getFullYear().toString().substring(2)}`;
        },
        formatDateWithoutYear(date) {
            return `${date.getDate()} ${this.convertMonthNumToStr(date.getMonth())}`;
        },
        convertMonthNumToStr(monthNum) {
            if (monthNum < 0 || monthNum > 11) {
                return undefined;
            }
            return MONTHS[monthNum];
        },
        getNextDate(numDays) {
            const now = Date.now();
            const nextDate = new Date(now + (numDays * DAY));
            nextDate.setHours(0,0,0,0);
            return nextDate;
        },
        getNextWeek() {
            return this.getNextDate(NUM_DAYS.week);
        },
        getNextFortnight() {
            return this.getNextDate(NUM_DAYS.fortnight);
        },
        getNextMonth() {
            return this.getNextDate(NUM_DAYS.month);
        }
    }
};
